export default "__VITE_ASSET__Bs3e4MUE__"